
console.log('process.env.REACT_APP_USE_TEST  :>> ', process.env.REACT_APP_USE_TEST);
export const url = process.env.REACT_APP_USE_TEST === "true"
    ? "https://backend.stravaporuch.com.ua" : "https://test-backend.stravaporuch.com.ua";